import React from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import { CardActionArea } from "@mui/material";
import David from "../../../assets/shortlist_22/david.jpg";
import Michael from "../../../assets/shortlist_22/michael.jpg";
import Mojisola from "../../../assets/shortlist_22/mojisola.jpg";
import Olusola from "../../../assets/shortlist_22/olusola.jpg";

const disabilityNominees = [
  {
    name: "David Anyaele",
    title: "Centre for Citizens with Disabilities",
    imgpath: David,
    story:
      "The Centre for Citizens with Disabilities (CCD) is a not-for-profit making and foremost human rights organization of, and for persons with disabilities that works to promote inclusion, participation, access, and the mainstreaming of issues of critical concern of citizens with disabilities in the programmes and activities of state and non-state institutions.",
  },
  {
    name: "Michael Thompson Showunmi",
    title: "Raising Star Africa",
    imgpath: Michael,
    story:
      "Raising Star African Foundation is a Non-governmental organization founded to support, empower and inspire quality education and life skills among differently-abled and less privileged children across Africa.",
  },
  {
    name: "Mojisola Odeyinde",
    title: "Disability Rights Advocacy Centre",
    imgpath: Mojisola,
    story:
      "Disability Rights Advocacy Centre (DRAC) is a not-for-profit Civil Society Organization that works to protect the rights of Persons with Disabilities (PWDs) and promote their inclusion in the Development Agenda. DRAC has a focus on women and girls with disabilities",
  },
  {
    name: "Olusola Owonikoko",
    title: "Project Enable",
    imgpath: Olusola,
    story:
      "Project Enable is a community development initiative that was founded in 2014 to advocate for the rights and empowerment of persons with disabilities in Nigeria. We believe that everyone deserves good quality life and that no one should be discriminated against on the account of their disability.",
  },
];

const DisabilityNominees = () => {
  return (
    <Grid
      item
      xs={12}
      md={12}
      marginTop={{ xs: "10%", sm: "3%" }}
      data-aos={"fade-up"}
    >
      <Typography
        variant={"h5"}
        fontWeight={400}
        paddingBottom={"2%"}
        color={"#049593"}
      >
        Disability Rights Advocacy / Empowerment Award (Shortlisted Nominees)
      </Typography>
      <Grid item xs={12} md={12} display={"flex"} flexWrap={"wrap"}>
        {disabilityNominees.map((nominate, index) => {
          const { name, title, imgpath, story } = nominate;
          return (
            <Grid
              key={index}
              item
              xs={12}
              md={3}
              marginBottom={{ xs: "7%", sm: "2%" }}
            >
              <Card
                sx={{
                  maxWidth: 260,
                  height: "100%",
                  borderTop: "10px solid #D7A036",
                }}
              >
                <CardActionArea>
                  <CardContent>
                    <Avatar
                      alt={name}
                      src={imgpath}
                      sx={{ width: 126, height: 126 }}
                    />
                    <Typography
                      gutterBottom
                      variant="h6"
                      color={"#004165"}
                      component="div"
                      textAlign={"center"}
                    >
                      {name}
                    </Typography>
                    <Typography
                      variant="body2"
                      fontWeight={700}
                      color="#049593"
                      paragraph
                      textAlign={"center"}
                    >
                      {title}
                    </Typography>
                    <Typography
                      paragraph
                      variant="body2"
                      fontWeight={400}
                      color="#4f4f4f"
                      textAlign={"center"}
                    >
                      {story}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Grid>
  );
};

export default DisabilityNominees;
